import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "100vh",

    overflow: "auto",
    fontFamily: "Roboto",
    "@media all and (max-width: 900px)": {
      height: "100vh",
      marginTop: 80,
      marginBottom: "10%",
    },
  },
  boxtitle: {
    width: "90%",
    display: "flex",
    color: "#4B4952",
  },
  boxTitle: {
    width: "90%",
    display: "flex",
    color: "#4B4952",
    margin: "15px 0%",
    marginLeft: "5%",
  },
  titleContainer: {
    borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
    display: "flex",
    // justifyContent: 'space-between'
  },
  iconContainer: {
    display: "flex",
    marginRight: "5%",
    "@media all and (max-width: 950px)": {
      marginRight: "8%",
    },
  },
  title: {
    fontSize: "2em",
    letterSpacing: "0.04rem",
    "@media all and (max-width: 600px)": {
      fontSize: "1.5em",
    },
  },
  iconStyle: {
    color: "#4B4952",
    marginRight: "2%",
    cursor: "pointer",
    paddingLeft: "25%",
  },

  titleAdd: {
    fontSize: "2em",
    letterSpacing: "0.04rem",
    "@media all and (max-width: 800px)": {
      fontSize: "1.5em",
      width: "80%",
    },
  },
  boxSubTitle: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    color: "#4B4952",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: "5%",
    marginTop: "0.5rem",
    "@media all and (max-width: 600px)": {
      fontSize: "0.8em",
    },
  },
  subtitle: {
    fontSize: "0.9rem",
    marginLeft: 8,
    fontWeight: "bold",
  },
  boxTable: {
    width: "95%",
    marginTop: "1rem",
    marginLeft: "5%",
  },
  boxButtonAdd: {
    marginTop: "1.2rem",
    marginLeft: "5.5%",
    display: "flex",
  },
  boxDetails: {
    width: "80%",
    marginLeft: "5%",
    marginTop: "2%",
    marginBottom: "2%",
    paddingBottom: 5,
    paddingTop: 5,
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
  },
  buttonCreateNotification: {
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 5,
    marginTop: "2%",
    marginLeft: "5%",
    border: "1px solid #dbdbdb",
    padding: 10,
    minWidth: "20%",
    maxWidth: "25%",
    borderLeft: "4px solid #00A88F",
    cursor: "pointer",
    color: "#008471",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.5)",
    },
  },
}))

export default useStyles
